import { useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import classNames from 'classnames';
import { Spin } from 'antd';
import styles from './style.module.scss';
import { getConfigForCenter, isValidCenter } from './config';
import { useVacancies } from './useVacancies';
import {
  VacanciesNavbar,
  VacanciesHero,
  VacancyList,
  VacancyDetailModal,
  VacanciesFooter,
} from './components';

const VacanciesPage = () => {
  const { shoppingCenter } = useParams();
  const validCenter = isValidCenter(shoppingCenter);
  const config = getConfigForCenter(shoppingCenter);
  const { vacancies, loading } = useVacancies(shoppingCenter);
  const [openVacancyId, setOpenVacancyId] = useState(null);

  const openVacancy = vacancies.find((v) => v.id === openVacancyId);
  const handleSelectVacancy = useCallback((id) => setOpenVacancyId(id), []);
  const handleCloseModal = useCallback(() => setOpenVacancyId(null), []);

  if (!validCenter) {
    return (
      <div className={styles.notFoundPage}>
        <p className={styles.notFoundCode} aria-hidden='true'>
          404
        </p>
        <p className={styles.notFoundMessage}>Pagina non trovata</p>
      </div>
    );
  }

  return (
    <div className={styles.vacanciesPage}>
      <VacanciesNavbar config={config} />

      <main className={classNames(styles.container, styles.jobsContent)}>
        <div className={styles.textCenter}>
          <VacanciesHero config={config} />
          {loading ? (
            <Spin />
          ) : (
            <VacancyList
              vacancies={vacancies}
              onSelectVacancy={handleSelectVacancy}
            />
          )}
        </div>
      </main>

      <VacanciesFooter />

      {openVacancy && (
        <VacancyDetailModal
          vacancy={openVacancy}
          visible={!!openVacancy}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default VacanciesPage;
